import { useEffect } from 'react';
import { Box, Icon, Link, Text } from '@nimbus-ds/components';
import { CogIcon } from '@nimbus-ds/icons';
import { useNavegate } from 'App/hooks';
import { useHeaderMenuData } from 'domains/Auth/hooks';
import { useGetInvoiceInfo } from 'domains/Billing/Invoices/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling/useTranslationBilling';
import { useFormatIdentificationByType } from 'domains/Orders/utils/useFormatIdentification';
import { ConsumidorFinalAlert } from './components';

function AccountDataContent(): JSX.Element {
  const t = useTranslationBilling('checkout.plansAndSubscriptions.accountData');
  const { name, url } = useHeaderMenuData();
  const { goTo } = useNavegate();
  const { fetchInvoiceInfo, invoiceInfo, isConsumidorFinal } =
    useGetInvoiceInfo();

  useEffect(fetchInvoiceInfo, [fetchInvoiceInfo]);

  const formattedIdentification = useFormatIdentificationByType({
    identification: invoiceInfo?.numberId ?? '',
    type: invoiceInfo?.numberIdType.toLowerCase() ?? '',
  });

  const urlShortened = url.replace('https://', '');
  const handleEditInvoiceInfo = () => goTo('/account/invoices/info');

  return (
    <Box display="flex" flexDirection="column" gap="4">
      <Box display="flex" flexDirection="column" gap="1">
        <Text fontWeight="bold" fontSize="highlight">
          {name}
        </Text>
        <div className="stratus--checkout-text_ellipsis">
          <Link appearance="primary" as="a" href={url} textDecoration="none">
            {urlShortened}
          </Link>
        </div>
        {!!invoiceInfo?.numberId && !!invoiceInfo.numberIdType && (
          <Text>{`${invoiceInfo.numberIdType}: ${formattedIdentification}`}</Text>
        )}
      </Box>
      {isConsumidorFinal && <ConsumidorFinalAlert />}
      <Box display="inline-flex" flexDirection="row" gap="1">
        <Link onClick={handleEditInvoiceInfo} textDecoration="none">
          <Icon color="primary-interactive" source={<CogIcon size="small" />} />
          <Text color="primary-interactive">{t('editInvoiceInfo')}</Text>
        </Link>
      </Box>
    </Box>
  );
}

export default AccountDataContent;
